import {
  UserContractsFragment,
  EmployeeFragment,
  VerificationStatus,
  PayControlKeyAvailabilityFragment,
} from '@/app/graphql/access-control/sdk.access-control';
import type { NptFragment } from '@/app/graphql/account/sdk.account.ts';

export interface User extends EmployeeFragment {
  currentContract: UserContractsFragment | null;
  authorized: boolean;
}
export interface UserEmpty {
  id: number | null;
  currentContract: UserContractsFragment | null;
  authorized: boolean;
  email: string;
  mobile: string;
  fullName: string;
  shortName: string;
  createdDate: string;
  individualInn: string;
  userReferenceId: number | null;
  userContracts: UserContractsFragment[] | null;
  postVerificationStatus: VerificationStatus | null;
}

export interface UserState {
  authorization: {
    isSmsConfirmation: boolean;
  };
  isSignSaveAvailable: boolean;
  isSignUpdateAvailable: boolean;
  showUserApproveDialog: boolean;
  isUserNotFound: boolean;
  nptData: NptFragment[];
  transactionKeyAvailability: PayControlKeyAvailabilityFragment;
  user: User | UserEmpty;
}

export function isUserAuthorized(something: User | UserEmpty): something is User {
  return (
    !!(something as User)?.id &&
    (something as User)?.authorized &&
    !!(something as User)?.userReferenceId &&
    !!(something as User)?.currentContract?.companyName
  );
}
